import { useCurrentMatch } from '@features/shared/hooks/use-current-match';

type NavbarConfig = {
  title: string;
  backgroundColor: string;
};

const NAVBAR_TITLE: Record<string, string> = {
  '/profile': 'Perfil',
  '/qrcode': 'Scanner',
  '/item-catalog/new': 'Novo item',
  '/item-catalog/:itemCatalogId': 'Editar item',
  '/item-catalog': 'Catálogo de itens',
  '/merchant/:merchantId': 'Notas',
  '/merchant/:merchantId/invoices/:invoiceId': 'Itens',
  '/merchant/:merchantId/invoices/:invoiceId/item/:invoiceItemId':
    'Detalhe do item',
};

export function useNavbarConfig(): NavbarConfig {
  const match = useCurrentMatch();

  return {
    title: NAVBAR_TITLE[match ?? ''] ?? 'Listare',
    backgroundColor: match === '/login' ? '#ffffff' : '#b5df9f',
  };
}
